// Design System — SuggestionChips constants
export const SUGGESTION_CHIPS_ICON = { ADD: 'plus' };

export const SUGGESTION_CHIPS_VARIANT = {
    // A dashed frame: the chip is a hint, not a thing that exists yet.
    DASHED: 'dashed',
    // A solid outline with the add sign leading, for pickers that list what can be added.
    OUTLINE: 'outline',
};

export const SUGGESTION_CHIPS_VARIANTS = Object.values(SUGGESTION_CHIPS_VARIANT);
